import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { ModuleComponent } from "../module.component";
import { GuideService } from "../../services/guide.service";
import { ScrollToService } from "ng2-scroll-to-el";
import { IdentityService } from "../../../services/identity.service";
import { ToastrService } from "ngx-toastr";

@Component({
  templateUrl: "./2B.component.html",
  styleUrls: ["../component.css"]
})
export class _2BComponent extends ModuleComponent {

  B12: string = ` `;

  constructor(router: Router, guideService: GuideService, modalService: BsModalService, scrollService: ScrollToService, identitySrv: IdentityService, toastr: ToastrService) {
    super(router, scrollService, guideService, modalService, identitySrv, toastr);

    this.titles.push({
      "activityId": "B11",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> the ways to network`
    });
    this.titles.push({
      "activityId": "B12",
      "html": `<i class="fas fa-sticky-note"></i><strong>Identify</strong> places to begin Networking.`
    });

    this.titles.push({
      "activityId": "B13",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activitiy response: Update the career plan dates for "Marketing Yourself​".`
    });


    this.titles.push({
      "activityId": "B21",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Learn</strong> about places to search for job openings:`
    });

    this.titles.push({
      "activityId": "B22",
      "html": `<i class="fab fa-youtube"></i> <strong>Learn</strong> how to track / organize job search.`
    });
    this.titles.push({
      "activityId": "B23",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activitiy response: Update the career plan dates for "Use a strategic job search to find a job​".`
    });    


    this.titles.push({
      "activityId": "B31",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Explore</strong> the proper way to apply for a job.`
    });
    this.titles.push({
      "activityId": "B32",
      "html": `<i class="fab fa-youtube"></i> <strong>Learn</strong> how to use the job tracker to tool to track the progress of your job search.`
    });
    this.titles.push({
      "activityId": "B33",
      "html": `<i class="fas fa-mouse-pointer"></i><strong>Complete</strong> this activity response: Update the career plan dates for "Apply for Jobs."`
    });

    this.titles.push({
      "activityId": "B41",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> ways to research the company before the interview.`
    });
    this.titles.push({
      "activityId": "B42",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> this activity response: Update the career plan dates for "Prepare for an interview."`
    });

    this.titles.push({
      "activityId": "B51",
      "html": `<i class="fas fa-file-import"></i> <strong>Test</strong> your knowledge of what you learned. These questions will be on the post-assessment test.`
    });



    this.group = 1;
    this.alpha = "B";

    this.activeMod = { group: 1, alpha: "B", number: 1 };
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.loadGuide();
  }
}
